import {getSuffixWithNumber} from '@utils/ordinalNumberSuffix';
import { BASE_FORM_MESSAGES } from '@constants/messages';
import {CONTENT_CATEGORY} from '@constants/resources';
import {CreateContentCategory, UpdateContentCategory} from '@graphql/contentCategory/mutation';
import {GetContentCategoryForForm} from '@graphql/contentCategory/query';

import validate from './validator';
import {prepareMessageText} from '../utils/contentCategoryHelpers';
import Form from '../../app/components/ReduxFormControls';

export default function ContentCategoryModel() {
    return {
        entityDataMapKey: 'contentCategory',
        entityLabel: 'content category',
        formName: 'content category',
        label: 'content category',
        resources: CONTENT_CATEGORY,
        showChangelog: true,
        title: (data, type, props) => (`Add new ${getSuffixWithNumber(props.formParams.level)} level category`),
        validate: validate,
        dataMap: {
            contentCategory: {
                id : '',
                name: '',
            },
        },
        messages: {
            boxName: {
                delete: 'contentCategoriesMessage',
                error: 'contentCategoriesMessage',
                success: 'contentCategoriesMessage',
            },
            text: { ...BASE_FORM_MESSAGES },
            create: {
                success: (data) => prepareMessageText(data),
                error: (data) => prepareMessageText(data, true),
            },
            update: {
                success: (data) => prepareMessageText(data),
                error: (data) => prepareMessageText(data, true),
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'contentCategory.id',
                props: {
                    hidden: true,
                    label: '',
                    name: 'id',
                },
            },
            name: {
                dataMapKey: 'contentCategory.name',
                props: {
                    component: Form.SemanticInput,
                    label: 'Name',
                    name: 'name',
                    required: true,
                    type: 'input',
                    autoFocus: true,
                },
            },
        },
        mutation: {
            createEntity: CreateContentCategory,
            updateEntity: UpdateContentCategory,
        },
        query: {
            getEntity: GetContentCategoryForForm,
        },
    };
}
